import * as XLSX from 'xlsx';
import { allHeaders } from './scheduleHeaders';

export function parseExcelFile(file: File): Promise<{ headers: string[]; data: Record<string, any>[] }> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const binaryStr = e.target?.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        if (!worksheet['!ref']) {
          reject(new Error('Worksheet is empty'));
          return;
        }

        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const headers: string[] = [];
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellRef = XLSX.utils.encode_cell({ c: C, r: range.s.r });
          const cell = worksheet[cellRef];
          headers.push(cell ? String(cell.v).trim() : `Column${C}`);
        }

        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '', raw: false }) as Record<string, any>[];
        const normalizedData = jsonData.map(row => {
          const normalized: Record<string, any> = {};
          for (const key in row) {
            if (Object.prototype.hasOwnProperty.call(row, key)) {
              const trimmedKey = key.trim();
              let value = row[key];
              if (typeof value === 'string') value = value.trim();
              normalized[trimmedKey] = value;
            }
          }
          return normalized;
        });

        resolve({ headers, data: normalizedData });
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(new Error('File reading error'));
    reader.readAsBinaryString(file);
  });
}

export function downloadExcel(data: Record<string, any>[], filename: string = 'validated-data.xlsx'): void {
  const worksheet = XLSX.utils.json_to_sheet(data, { header: allHeaders });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, filename);
}

export function generateTemplate(): void {
  const sampleRow: Record<string, any> = {};
  allHeaders.forEach(h => { sampleRow[h] = ''; });
  const worksheet = XLSX.utils.json_to_sheet([sampleRow], { header: allHeaders });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
  XLSX.writeFile(workbook, 'schedule-template.xlsx');
}
